import React from 'react';

import { Card } from 'components/Container';

interface IMissingToken {}

export const MissingToken = (props: IMissingToken) => {
	return (
		<Card hatColor="text-danger-500">
			<div className="text-danger-500 font-bold text-lg md:text-2xl text-center mb-6">
				Missing Token. Please open your received link.
			</div>
			<div className="flex flex-1 flex-wrap self-center text-sm md:text-md">
				<div className=" text-center">Having problems? Feel free to contact us</div>
				<div className="cursor-pointer underline ml-1" onClick={() => window.open('mailto:hello@bitsandpretzels.com')}>
					here
				</div>
			</div>
		</Card>
	);
};
